import { useEffect, useState } from "react";
import { BaseFormData, FormStore, FormStoreOptions } from "../formx";

type Options<T extends BaseFormData> = FormStoreOptions<T> & {
  exposeAs?: string;
};

export function useFormStore<T extends BaseFormData>(options: Options<T>) {
  const [store] = useState(() => new FormStore(options));

  useEffect(() => {
    if (options.exposeAs) {
      (window as any)[options.exposeAs] = store;
    }
  });

  return store;
}
